<template>
  <div id="app">
    <!-- <keep-alive>
      <router-view v-if="isRouterAlive" />
    </keep-alive> -->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive && isRouterAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive && isRouterAlive"></router-view>
  </div>
</template>

<script>
import { htmlAppBuildInfo } from './api/app-build-info/app-build-info'

export default {
  name: "App",
  data() {
    return { isRouterAlive: true };
  },
  provide() {
    //父组件中通过provide来提供变量，在子组件中通过inject来注入变量。
    return {
      reload: this.reload,
      loopTimer: null
    };
  },
  computed: {},
  watch: {},
  created() {
    console.log(this.Config, this.UtilFn, '-------------------------APP.vue----------------------')
  },
  mounted () {
    this.loopJsonTimer()

  },
  beforeDestroy () {
    clearInterval(this.loopTimer)
  },
  methods: {
    reload() {
      this.isRouterAlive = false; //先关闭，
      this.$nextTick(function () {
        this.isRouterAlive = true; //再打开
      });
    },
    /**
     * webview检查版本是否最新
     * @returns void
     */
    webviewCheckVersionIsLatest (success = () => {}, fail = () => {}) {
      // 如果NODE_ENV === 'production'，则执行loopGetAppBuildInfoJson
      if (window.appBuildInfo && window.appBuildInfo.NODE_ENV === 'production' && this.Config.showUpdateTip) {
        const params = {}
        htmlAppBuildInfo(params).then((res) => {
          if (res) {
            const { data } = res.data
            if (window.appBuildInfo.uniqueKey !== data.uniqueKey) {
              success(data)
            }
          }
        }).catch((err) => {
          fail(err)
        })
      } else {
        console.log('-------------------------未满足条件,不需要检测更新----------------------')
      }
    },
    loopJsonTimer () {
      const self = this
      this.loopTimer = setInterval(() => {
        self.webviewCheckVersionIsLatest((res) => {
          console.log('-------------------------webviewCheckVersionIsLatest/res----------------------')
          self.showGlobalNotify({ message: '检测到网页更新，请及时刷新页面' })
        }, (err) => {
          console.log(err.data.msg, '-------------------------webviewCheckVersionIsLatest/err----------------------')
        })
      }, 60000)
    },
    showGlobalNotify (data) {
      this.$notify({
        title: data.message,
        type: 'warning'
      })
    },
    testRenderSpecList () {
      const arrays = [
        [{name: 'attr1', sort: 1},{name: 'attr2', sort: 2},{name: 'attr3', sort: 3}],  
        [{name: 'attr4', sort: 4},{name: 'attr5', sort: 5}],  
        [{name: 'attr6', sort: 6},{name: 'attr7', sort: 7},{name: 'attr8', sort: 8}]  
      ]
      const result = this.UtilFn.combineSpecNames(arrays)
      console.log('spec---------------')
      console.log(result)
    }
  },
};
</script>
<style lang="scss">
@import "@/styles/variables.scss";
@import "@/styles/main.scss";
#app {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.text-theme {
  color: $mainBg;
}
.bg-theme {
  background-color: $mainBg;
}
body::-webkit-scrollbar {
  display: none;
}
</style>
